export const data = [
    {
        id:1,
        name:'Manges Vasiya',
        designation:'Founder-vyas computers',
        img:'assets1/img/client-logo/testimonial1.jpeg',
        content:'The design for my new website was conceived in a short amount of time. After a few initial changes, the final product came out just the way we hoped. We routinely receive compliments about the quality of our website. I cannot adequately express the value our new website brings us. Unlock Technologies’ prompt responses and friendly approach is what we liked most about working with your company.'
    },
    {
        id:2,
        name:'Sarvjeet Yadav',
        designation:'CEO & Founder-Riya optics',
        img:'assets1/img/client-logo/testimonial2.jpeg',
        content:'I had a few things I needed help with on this template... Their customer service was amazing and helped me out many times. All fits and works well and good!! Top marks. One of the complete template with different requirements. Thanks a lot for such great features, pages, shortcodes and home variations. Incredible Job.'
    },
    {
        id:3,
        name:'Amarjeet Yadav',
        designation:'Founder-Uttar Yadav Yuva Sangh',
        img:'assets1/img/client-logo/testimonial3.png',
        content:'All fits and works well and good!! Top marks. One of the complete template with different requirements. Thanks a lot for such great features, pages, shortcodes and home variations. Incredible Job.'
    },
]